import { AccountModel, ROLE_IDS } from '@/lib/models';

const INQUIRY_CLIENT_SELECTION_ROLE_IDS = [ROLE_IDS.ADVISOR, ROLE_IDS.ACCOUNT_MANAGER, ROLE_IDS.GRC_ADVISOR];

export const canSelectInquiryClient = (account?: Pick<AccountModel, 'roles'>) => {
	return account?.roles?.some((role) => INQUIRY_CLIENT_SELECTION_ROLE_IDS.includes(role)) ?? false;
};
